var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "navGray",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#404040",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color",
    in2: "SourceGraphic",
    operator: "in"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_943",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_943",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_943",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEZklEQVR4nO2dz6sVZRjHT5H201DrupLcdUXLjS70L2gRQou6RhtFS4laBAUFar24ELOSfpObSDp2wzYKpQvB4poQqHfTtUU/oF/apgQNMoX6yAvvxUuv3Zk555nzPHPm+cDsDvP9znw4M3PmvDNvp+M4juM4juM4jtMAgDuBdcAeoAscEF7GgTeAx4FFgr0XAU+kdY/X0Lub9skYME+q92wbdDPwEvAng+MK8A6wsI/edwHvpnUNiovA9rjPZC1c26gR4AR6fAeM9tB7KfCDYu8vgbulZcwFvkCfH6scwuKOUJYxzQnRbwoQsMNHFXp/gh22S57A4/HQCv8Cy0v0vj991goXRU70wKPYI5TovQN7jEkIeQ17fFai9xHs8YqEkP0FIb/UcD1/piBzskTvyYJ1nKmhd9wXs9GVEBKDZuNA3yHVLyKmSqxjqt/Dnsl95ULK40JmwYUIggtRDskzgwvRDMkzgwvRDMkzgwvRDMkzgwvRDMkzgwvRDMkzgwvRDMkzgwvRDMkzgwvRDKlHyMmCdZwDTgkv5wsy97VZyCHssbPNQp7DHg+0WcgS4DJ2OBsHi7RWSAR4HTts6kjQcCG3AF+hTxz9ckOn7UJmjFo8hh7vS4/JarSQCHAT8CTwK4Pja+ChjjTDIGQa4EZgdRrEHTN2CS/bgPXAsk5dDJOQocCFGMOFGMOFGMOFGMOFGMOFNE/IUWCl8LK3TiHAgviMSQ294+Nzt8vt/euXL9o5Gkz0sB33AG+WGKEuwTfpWz6/DiEvYI8PKm7DM8AlhZ5/AGulhazAHusq9H9Zues/8XaKtJQJ7PAzcGvJ3o9hg7/jOUZSyCpD/749UrLzbelfusae94o2cH36+jVikAB2vh0zWSEtZS3wu8KG/AU8XbHrh9jjeVEhaUPnp0u6ogczJfgp/S++uIeex7HHe+JCrnOcHq3hB9byfq/hS4xc3FtD7/gjeaB3NRoDwzqUtKngQmyBC7EFLsQWuBBb4EJsQduEpBeEbYi/PmtaNgNr4uC2Hvu1Q0i8uZf+gBkUZ4GngDkVew63kPSKWM37Q5/HgdMV+g6vkDiUPr58En1Ox9s1JTsPtZAt2GFPq4WkQ9Vv2OFyHLDQZiEPYo9n2ywkPvdgjYNtFrKvIOR8DQ/gnyvIPNlmIY0cSooLkQMXohySZwYXohmSZwYXohmSZwYXohmSZwYXohmSZwYXohmSZwYXohmSZwYXohmSZwYXohmSZwYXohmSZwYX8v8hPuURtqY8ehV7fFqi92HssVtCSJyE2BovNmwyzGkelhAyz+DEkstK9L7P2MSSF8RmkE6zHlthf4XeH2OHrSIy0obNMTQ58UjFF2AO3+TEM2ZejlNRa/EtcG8PveP7R75X7H1cfPru/wwJ2jbgc8oV4K34wpg+ei8E3h7wBPfxnLFV5G3WJU/0Y+mSuFvD9fx4evp2Y5VDVIneI/EN02nd4zX07qZ9Esc/3yHV23Ecx3Ecx3Ecp1MjVwEVuUfdTSBofwAAAABJRU5ErkJggg=="
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_173_943)",
    filter: "url(#navGray)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7b9c5bafcee1e2e26297e486c6e5e4fe.svg";
export { ForwardRef as ReactComponent };